import React from "react";
import { Table } from "antd";

const PaymentsTab = ({ data }) => {
  return (
    <Table
      dataSource={data}
      rowKey={(r) => r.id}
      pagination={false}
      columns={[
        { title: "Invoice No", dataIndex: "invoice_id" },
        { title: "Method", dataIndex: "channel" },
        { title: "Amount", dataIndex: "amount" },
        { title: "Transaction ID", dataIndex: "trans_id" },
        {
          title: "Date",
          dataIndex: "created_at",
          render: (v) => new Date(v).toLocaleString(),
        },
      ]}
    />
  );
};

export default PaymentsTab;
